// @ts-nocheck -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved.
import { useEffect, useState } from "react";
import useTranslation from "next-translate/useTranslation";
import PropTypes from "prop-types";
import Cookies from "js-cookie";

import { Box, Button, Dialog, Form, Typography } from "@/components/core";
import { usePhoneConfirmStore } from "@/store/phone-confirm";

export function SMSVerificationDialog({ open, onClose, time = 90, onSubmit }: any) {
  const MINUTE = 60;
  const { t } = useTranslation("common");

  const [code, setCode] = useState("");
  const [remainingTime, setRemainingTime] = useState();

  const handleChange = (val: any) => {
    setCode(val);
  };

  const handleSubmit = () => {
    onSubmit(code);
    usePhoneConfirmStore.getState().setOpen(false);
  };

  const handleResend = () => {
    // resend logic
    setRemainingTime(time);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setRemainingTime((prev) => Math.max(--prev, 0));
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    setRemainingTime(time);
    setCode("");
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose} title={t("confirm")} defaultTitle>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          gap: 1,
        }}
      >
        <Typography variant="caption">{t("smsVerificationMessage")}</Typography>
        <Typography bold>{Cookies.get("phone-number")}</Typography>
        <Form
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            gap: 1,
          }}
        >
          {remainingTime > 0 ? (
            <Form.CodeVerification
              value={code}
              variant="filled"
              length={6}
              onChange={handleChange}
            />
          ) : (
            <Typography color="error">{t("codeIsExpired")}</Typography>
          )}
          <Button color="inherit" onClick={handleResend}>
            {t("resend")}
          </Button>
          <Typography variant="caption">
            {`${Math.floor(remainingTime / MINUTE)}:${
              remainingTime % MINUTE < 10 ? `0${remainingTime % MINUTE}` : remainingTime % MINUTE
            } ${t("minute")}`}
          </Typography>
          <Button variant="contained" disabled={code.length !== 6} onClick={handleSubmit}>
            {t("continue")}
          </Button>
        </Form>
      </Box>
    </Dialog>
  );
}

SMSVerificationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  time: PropTypes.number,
  onSubmit: PropTypes.func,
};
